import tw from 'twin.macro';

type SpacerProps = {
  direction: 'horizontal' | 'vertical';
  size: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl';
};

const sizeVariants = {
  xxs: tw`w-1 h-1`,
  xs: tw`w-2 h-2`,
  sm: tw`w-3 h-3`,
  md: tw`w-4 h-4`,
  lg: tw`w-5 h-5`,
  xl: tw`w-6 h-6`,
  xxl: tw`w-7 h-7`,
  xxxl: tw`w-8 h-8`,
};

const directionVariants = {
  horizontal: tw`h-full`,
  vertical: tw`w-full`,
};

const Spacer = ({ direction, size }: SpacerProps) => {
  return <div css={[sizeVariants[size], directionVariants[direction]]} />;
};

export { Spacer };
